import { Component, HostBinding } from "@angular/core";
import { Toast, ToastPackage, ToastrService } from "ngx-toastr";
import { NgZone } from "@angular/core";

@Component({
    selector: "[toast-component]",
    template: `
        @if (options.closeButton) {
            <button (click)="remove()" type="button" class="toast-close-button" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        }
        @if (title) {
            <div [class]="options.titleClass" [attr.aria-label]="title">
                {{ title }} @if (duplicatesCount) {[{{ duplicatesCount + 1 }}]}
            </div>
        }
        @if (message && options.enableHtml) {
            <div role="alert" [class]="options.messageClass" [innerHTML]="message"></div>
        }
        @if (message && !options.enableHtml) {
            <div role="alert" [class]="options.messageClass" [attr.aria-label]="message">
                {{ message }}
            </div>
        }
        @if (options.progressBar) {
            <div>
                <div class="toast-progress" [style.width]="width + '%'"></div>
            </div>
        }
    `,
})
export class ToastComponent extends Toast {
    @HostBinding("attr.data-testid")
    get testId(): string {
        return this.toastPackage.toastType;
    }

    constructor(
        toastrService: ToastrService,
        toastPackage: ToastPackage,
        ngZone: NgZone,
    ) {
        super(toastrService, toastPackage, ngZone);
    }
}
